export const gold = "#FDDF8C";
export const darkGold = "#F1C416";
export const lightGold = "#FFEEC6";
export const darkBlack = "#252022";
export const black = "#939599";
export const lightBlack = "#C7C9CA";
export const blueTextCOlor = "#0262b6";
